/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	InventoryMarkInvoicedPathParams,
	InventoryMarkInvoicedRequest,
	InventoryMarkInvoicedResponse,
} from '../types/InventoryMarkInvoiced'

/**
 * PATCH /:organisation/inventory/:item/invoiced
 * @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::markInvoiced
 */
export async function inventoryMarkInvoiced(
	organisation: InventoryMarkInvoicedPathParams['organisation'],
	item: InventoryMarkInvoicedPathParams['item'],
	data: InventoryMarkInvoicedRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InventoryMarkInvoicedResponse>> {
	return axiosInstance.patch(`/${organisation}/inventory/${item}/invoiced`, data, config)
}
